import React from "react";
import { Html5Entities } from "html-entities";

function Card(props) {
  let links_from_API;
  if (props.card_data.links){
    links_from_API = JSON.parse(props.card_data.links);
    console.log("links_from_API: ", links_from_API);
  }
  let counter = 1;
  let links;
  if (links_from_API) {
    links = links_from_API.map((link) => {
      if (link !== "") {
        return (
          <a style={{ display: "inline-block", marginRight: 10 }} href={link} key={counter++}>
            Ссылка {counter} 
          </a>
        );
      } else {
        return "";
      }
    });
  } else {
    links = "";
  }

  let card_text = '';  
  card_text = (props.card_data.text).replace(/(\n)/g, "<br>");
  if(card_text){
    card_text = card_text.replace(/(https:\/\/[/A-Za-z.\d_?=-]+)/g, replacer);
  }  

  function replacer(match) {
    return `<a href="${match}">${match}</a>`;
  }  

  const htmlEntities = new Html5Entities();
  return (
    <div
      className="card text-dark bg-light mb-3"
      style={{ width: "19.5rem", marginBottom: "1rem" }}
    >
      <div>
        <img
          style={{ display: props.card_data.img_path ? "block" : "none" }}
          src={htmlEntities.decode(props.card_data.img_path)}
          className="card-img-top"
          alt={props.card_data.text}
        />
        {/* <div className="card-img-overlay" title={props.card_data.text}>
          <h5 className="card-title" style={{ color: "white", fontSize: 24 }}>
            &hearts;
          </h5>
        </div> */}
      </div>
      <div
        className="card-body"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <h5 className="card-title" style={{ height: "auto" }}>
          {props.card_data.post_title}
        </h5>
        <p dangerouslySetInnerHTML={{__html: card_text }} >
        </p>
        <div
          style={{
            display: "flex",
            alignContent: "flex-start",
            flexWrap: "wrap",
            marginBottom: 16
          }}
        >
          {links}
        </div>
        <a
          style={{ display: "block", marginTop: "auto" }}
          href={htmlEntities.decode(props.card_data.post_path)}
          className="btn btn-outline-secondary"
        >
          Go to post
        </a>
      </div>
      <div
        className="card-footer text-muted"
        style={{
          height: "3rem",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <a
          style={{
            color: "#ccc",
            textDecoration: "none",
          }}
          href={props.card_data.account_path}
        >
          {props.card_data.social_net}
        </a>
        {props.card_data.hashtags}
      </div>
    </div>
  );
}

export default Card;